import React, { useSyncExternalStore } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { EyeOff } from 'lucide-react';
import { hasControl } from '../../redux/subscriptionSlice';
import { getCurrentOrg, subscribeOrg } from '../../utils/orgWords';

// "YOUR PLAN DOES NOT LIST YOU IN THE PLATFORM DIRECTORY" (owner, 1 Oct 2026).
//
// directory_listing is a plan control with nothing to hide on this side: the
// server simply leaves the doctor out of the open platform's directory that
// patients search. A doctor would never find that out from their own screens,
// so their dashboard and profile say it — one quiet line, no button.
//
// Drawn only when ALL of these hold:
//   · the signed-in user is a doctor;
//   · the tenant is the open platform (org.kind 'moc') — a hospital's doctors
//     are not in that directory whatever their plan says;
//   · the plan rule governs this doctor (`planApplies === true`, from the
//     resolved access — false at a tenant without `subscriptions`, and absent
//     until the answer arrives, so the line never flashes on load);
//   · the plan lacks directory_listing.
export default function DirectoryListingNote({ className = '' }) {
    const { t } = useTranslation();
    const org = useSyncExternalStore(subscribeOrg, getCurrentOrg, getCurrentOrg);
    const access = useSelector((state) => state.subscription?.doctorAccess);
    const role = ((typeof localStorage !== 'undefined' && localStorage.getItem('Role')) || '').toLowerCase();

    if (role !== 'doctor') return null;
    if (org?.kind !== 'moc') return null;
    if (access?.planApplies !== true) return null;
    if (hasControl(access?.controls, 'directory_listing')) return null;

    return (
        <p
            data-testid="directory-listing-note"
            className={`flex items-center gap-2 text-xs text-slate-500 ${className}`}
        >
            <EyeOff className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" />
            {t('planGate.directory_unlisted', 'Your plan does not list you in the platform directory')}
        </p>
    );
}
